import { createSlice } from "@reduxjs/toolkit";
import {
  AddColorAction,
  DeleteColorAction,
  UpdateColorAction,
  GetAllColorAction,
} from "store/middlewares/dataManagement/color";

export const colorSlice = createSlice({
  name: "color",
  initialState: {
    colorLoading: true,
    color: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllColorAction.pending, (state) => {
        // state.colorLoading = true;
        // state.color = null;
        state.color = state.color?.data?.length > 0 ? state.color : null;
      })
      .addCase(GetAllColorAction.fulfilled, (state, action) => {
        state.colorLoading = false;
        state.color = action.payload.response;
      })
      .addCase(GetAllColorAction.rejected, (state) => {
        state.colorLoading = false;
        state.color = null;
      })

      //add
      .addCase(AddColorAction.fulfilled, (state, action) => {
        // state.colorLoading = false;
        // state.color = {
        //   ...state.color,
        //   total: Number(state.color.total) + 1,
        //   data: [action.payload.response, ...state.color.data],
        // };
        state.colorLoading = false;
        state.color = action.payload.response;
      })

      //delete
      .addCase(DeleteColorAction.fulfilled, (state, action) => {
        // state.colorLoading = false;
        // state.color = {
        //   ...state.color,
        //   total: Number(state.color.total) - 1,
        //   data: state.color?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.colorLoading = false;
        state.color = action.payload.response;
      })
      //update
      .addCase(UpdateColorAction.fulfilled, (state, action) => {
        state.colorLoading = false;
        state.color = {
          ...state.color,
          data: state.color.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      });
  },
});

export default colorSlice.reducer;
